var selectors = {
  hamburgerMenu: "[data-hamburger-menu]",
  mobileNavigation: "[js-mobile-navigation]",
  parentLinks: "[js-mobile-link]",
  childNavigation: "[js-child-navigation]",
  parentNavigation: "[js-parent-navigation]",
  backButton: "[js-back-button]",
  closeButton: "[data-menu-mb-toogle]",
};

const hamburgerMenu = document.querySelector(selectors.hamburgerMenu);
const mobileNavigation = document.querySelector(selectors.mobileNavigation);
const parentLinks = document.querySelectorAll(selectors.parentLinks);
const parentNavigation = document.querySelector(selectors.parentNavigation);
const childNavigation = document.querySelector(selectors.childNavigation);
const backButtons = document.querySelectorAll(selectors.backButton);
const closeButton = document.querySelector(selectors.closeButton);

if (hamburgerMenu) {
  hamburgerMenu.addEventListener("click", (e) => {
    e.preventDefault();

    if (mobileNavigation) {
      if (mobileNavigation.classList.contains("active")) {
        mobileNavigation.classList.remove("active");
        document.body.parentNode.classList.remove("stop-scroll");
        closeButton.classList.remove("menu-open");
      } else {
        if (parentNavigation) parentNavigation.classList.remove("hidden");
        if (childNavigation) childNavigation.classList.remove("active");
        mobileNavigation.classList.add("active");
        document.body.parentNode.classList.add("stop-scroll");
        closeButton.classList.add("menu-open");
      }
    }
  });
}

backButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    if (parentNavigation) parentNavigation.classList.remove("hidden");
    if (childNavigation) childNavigation.classList.remove("active");

    const items = document.querySelectorAll("[js-mobile-content]");
    items.forEach((item) => {
      item.classList.add("hidden");
    });
  });
});

parentLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    if (childNavigation) childNavigation.classList.add("active");
    if (parentNavigation) parentNavigation.classList.add("hidden");

    const title = link.getAttribute("data-title");
    const items = document.querySelectorAll("[js-mobile-content]");

    mobileNavigation.scrollTo(0, 0);

    items.forEach((item) => {
      const itemTitle = item.getAttribute("data-title");

      if (title == itemTitle) {
        item.classList.remove("hidden");
      } else {
        item.classList.add("hidden");
      }
    });
  });
});

closeButton.addEventListener("click", (e) => {
  e.preventDefault();

  if (mobileNavigation) {
    if (mobileNavigation.classList.contains("active")) {
      mobileNavigation.classList.remove("active");
      document.body.parentNode.classList.remove("stop-scroll");
      closeButton.classList.remove("menu-open");
    }
  }
});
